import { FormattedMessage } from "react-intl";
import dayjs from "../../../../mydayjs";
import Dropdown from "../../../cmp/Dropdown";
import React from "react";

const rangeToDates = {
  thismonth: [
    dayjs().startOf("month").format("YYYY-MM-DD"),
    dayjs().endOf("month").format("YYYY-MM-DD"),
  ],
  lastmonth: [
    dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
    dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
  ],
  last30days: [
    dayjs().subtract(30, "day").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ],
  alltime: [0, dayjs().format("YYYY-MM-DD")],
  "last60days":[
    dayjs().subtract(60,'day').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD')
  ],
  "last90days":[
    dayjs().subtract(90,'day').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD')
  ],
  "last5days":[
    dayjs().subtract(5,'day').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD')
  ],
  "last10days":[
    dayjs().subtract(10,'day').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD')
  ]
};
const opts = [
  {
    label: <FormattedMessage id={"This month"}/>,
    value:'thismonth'
  },
  {
    label:  <FormattedMessage id={"Last month"}/>,
    value:'lastmonth'
  },
  {
    label: <FormattedMessage id={"Last 5 days"}/>,
    value:'last5days'
  },
  {
    label: <FormattedMessage id={"Last 10 days"}/>,
    value:'last10days'
  },
  {
    label: <FormattedMessage id={"Last 30 days"}/>,
    value:'last30days'
  },
  {
    label: <FormattedMessage id={"Last 60 days"}/>,
    value:'last60days'
  },
  {
    label: <FormattedMessage id={"Last 90 days"}/>,
    value:'last90days'
  },
  {
    label:   <FormattedMessage id={"All time"}/>,
    value:'alltime'
  },
]
function DateRangeDropdown({ selectedRange, onSelected }) {
  return (
    <Dropdown
      onSelected={onSelected}
      selected={opts.find((item) => item.value === selectedRange)?.value}
      opts={opts}
    />
  );
}

export { rangeToDates };
export default DateRangeDropdown;
